import * as React from "react";
import { Grid, Form } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { MasterQuestionConfig, QuestionConfig, isQuestionDisabled } from "@teamprevent/common/questionnaires/questionnaireConfig/models";
import { TermsAndConditionsOfUseConfig } from "@teamprevent/common/termsAndConditions/model";

interface Props {
    masterQuestion: MasterQuestionConfig;
    customQuestion: QuestionConfig;
    onChanged: (questionConfig: QuestionConfig) => void;
    questionnaireType: string;
    customQuestionText?: string;
}

export const QuestionEdit: React.FunctionComponent<Props> = (props: Props) => {

    const onTextChanged = (text: string) => {
        if (isQuestionDisabled(props.customQuestion)) {
            return;
        }

        if (text !== ((props.customQuestion && props.customQuestion.questionText) || props.masterQuestion.questionText)) {
            props.onChanged({
                id: props.masterQuestion.id,
                questionText: text,
                isMandatory: props.customQuestion?.isMandatory !== undefined ? props.customQuestion.isMandatory : true
            });
        }
    };

    const onDisabledChanged = (checked: boolean) => {
        if (checked !== !!(props.customQuestion && isQuestionDisabled(props.customQuestion))) {
            if (checked) {
                props.onChanged({
                    id: props.masterQuestion.id,
                    disabled: true,
                    isMandatory: props.customQuestion?.isMandatory !== undefined ? props.customQuestion.isMandatory : true
                });
            } else {
                props.onChanged({
                    id: props.masterQuestion.id,
                    questionText: !props.customQuestion || isQuestionDisabled(props.customQuestion)
                        ? props.masterQuestion.questionText
                        : props.customQuestion.questionText,
                    isMandatory: props.customQuestion?.isMandatory !== undefined ? props.customQuestion.isMandatory : true
                });
            }
        }
    };

    const isDisabled = isQuestionDisabled(props.customQuestion ?? props.masterQuestion);

    return (
        <Grid container columns={2} divided className="question-config">
            <Grid.Row>
                {props.questionnaireType === TermsAndConditionsOfUseConfig
                    ? <Grid.Column>{props.customQuestionText}</Grid.Column>
                    : <Grid.Column as="h4">{props.masterQuestion.questionText}</Grid.Column>
                }
                <Grid.Column>
                    <Form>
                        {props.masterQuestion.canBeDisabled &&
                            <Input.Checkbox
                                label="Question disabled"
                                value={isDisabled}
                                onChange={onDisabledChanged}
                            />
                        }
                        {!isQuestionDisabled(props.customQuestion) &&
                            <Input.Textarea
                                disabled={isDisabled}
                                value={props.customQuestion ?
                                    props.customQuestion.questionText :
                                    props.masterQuestion.questionText}
                                onChange={onTextChanged}
                            />}
                    </Form>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
